import { Control, Controller, FieldValues } from 'react-hook-form';

import { Dropdown, DropdownProps } from './';

type Props = {
  name: string;
  control: Control<FieldValues>;
};

const FormDropdown = ({ control, name, ...props }: Props & DropdownProps) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, value, ref } }) => {
        return <Dropdown {...props} value={value} ref={ref} onChange={onChange} />;
      }}
    />
  );
};

export default FormDropdown;
